import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import ExpandableSection from "../../expandablesection";
import SideLiteSearch from "./SideLiteSearch"; // Import SideLiteSearch component

const PanelSideLite = forwardRef(({ onChange }, ref) => {
  const [sideLiteSearchValue, setSideLiteSearchValue] = useState(""); // Updated state for SideLiteSearch

  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        const element = document.getElementById(control.id); // Query by control ID
        if (element) {
          values[control.id] = element.value; // Retrieve the current value
        } else {
          values[control.id] = null; // Handle missing elements
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));

  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      sideLiteSearch: sideLiteSearchValue, // Updated the property name for SideLiteSearch
    });
  }, [sideLiteSearchValue, onChange]);

  // Control map specific to SideLite
  const controlMap = [
    {
      id: "SideLiteSearch",
      component: (
        <SideLiteSearch
          id="SideLiteSearch"
          placeholder="Search..." // Placeholder for the search input
          onChange={(newValue) => {
            setSideLiteSearchValue(newValue); // Update state for SideLiteSearch
          }}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "SideLite",
    },
  ];

  return (
    <ExpandableSection
      title="Side Lite"
      panelLocation="117"
      controlMap={controlMap.filter((control) => control.expandableSectionId === "SideLite")}
    />
  );
});

export default PanelSideLite;
